<template>
  <div class="Grid HomePagePadding">
    <div class="HeadingWrapper">
      <div class="text-qwraysuperlight tracking-2.4px subtitle">
        {{ $t('our_focus.small_header') }}
      </div>
      <div class="mt-5 BigHeader font-Foco text-qwray lg:leading-50px heading">
        {{ $t('our_focus.big_header') }}
      </div>
    </div>
    <div class="TextWrapper">
      <div class="mt-5 text-qwray text-body">
        {{ $t('our_focus.txt1') }}
      </div>
      <div class="mt-5 text-qwray text-body">
        {{ $t('our_focus.txt2') }}
      </div>
    </div>
    <div class="Circle" />
    <div class="Layer" />
    <div class="PoleImageWrapper">
      <picture>
        <source
          type="image/webp"
          media="(min-width: 768px)"
          :srcset="
            SHOW_NON_QWELLO_POLES
              ? require('@/assets/experiencePage/pole-homepage-bottom-POLAND.webp')
              : require('@/assets/experiencePage/pole-homepage-bottom.webp')
          "
        />
        <source
          type="image/jpeg"
          media="(min-width: 768px)"
          :srcset="
            SHOW_NON_QWELLO_POLES
              ? require('@/assets/experiencePage/pole-homepage-bottom.jpg')
              : require('@/assets/experiencePage/pole-homepage-bottom.jpg')
          "
        />
        <source
          type="image/webp"
          :srcset="
            SHOW_NON_QWELLO_POLES
              ? require('@/assets/experiencePage/pole-homepage-bottom-POLAND.webp')
              : require('@/assets/experiencePage/pole-homepage-bottom.webp')
          "
        />
        <source
          type="image/jpeg"
          :srcset="
            SHOW_NON_QWELLO_POLES
              ? require('@/assets/experiencePage/pole-homepage-bottom-POLAND.jpg')
              : require('@/assets/experiencePage/pole-homepage-bottom.jpg')
          "
        />
        <img
          class="PoleImage"
          :srcset="
            SHOW_NON_QWELLO_POLES
              ? (require('@/assets/experiencePage/pole-homepage-bottom-POLAND.jpg') +
                  ' 345w',
                require('@/assets/experiencePage/pole-homepage-bottom-POLAND.jpg') +
                  ' 916w')
              : (require('@/assets/experiencePage/pole-homepage-bottom.jpg') +
                  ' 345w',
                require('@/assets/experiencePage/pole-homepage-bottom.jpg') +
                  ' 916w')
          "
          :src="
            SHOW_NON_QWELLO_POLES
              ? require('@/assets/experiencePage/pole-homepage-bottom-POLAND.jpg')
              : require('@/assets/experiencePage/pole-homepage-bottom.jpg')
          "
          sizes="(max-width: 768px) 345px, 916px"
        />
      </picture>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import { SHOW_NON_QWELLO_POLES } from '../../shared/entityHelpers';

export default {
  data() {
    return {
      SHOW_NON_QWELLO_POLES,
    };
  },
};
</script>

<style scoped>
.Grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: 3fr 2.9fr 1fr;
  overflow: hidden;
  min-height: auto;
  --subtitle-f-size: 16px;
  --heading-f-size: 70px;
  --text-f-size: 17px;
}
.subtitle {
  font-size: var(--subtitle-f-size);
}
.heading {
  font-size: var(--heading-f-size);
}
.text-body {
  font-size: var(--text-f-size);
}

.HeadingWrapper {
  grid-row: 1;
  grid-column: 1 / 4;
  align-self: flex-end;
}
.TextWrapper {
  padding-top: 1.5em;
  align-self: flex-start;
  grid-row: 2;
  grid-column: 1 / 4;
}
.PoleImageWrapper {
  grid-column: 4 / -1;
  grid-row: 1 / 4;
  align-self: center;
  justify-self: flex-end;
}
.PoleImage {
  object-fit: cover;
}
.Circle {
  grid-row: 2 / -1;
  grid-column: 3 / -1;
  background: #ffdf22;
  border-radius: 60% 40% 100% 0% / 100% 100% 0% 0%;
  z-index: -1;
}
.Layer {
  grid-row: 2 / -1;
  grid-column: 5/ -1;
  background: #ffdf22;
}
.BigHeader {
  font-weight: bold;
}
@media (min-width: 1450px) {
  .TextWrapper {
    margin-bottom: 110px;
    max-width: 74%;
  }
}
@media (min-width: 1750px) {
  .Grid {
    min-height: 100vh;
  }
  .BigHeader,
  .TextWrapper {
    max-width: 80%;
    margin-bottom: unset;
  }
  .PoleImageWrapper {
    height: 60%;
  }
}
@media (max-width: 1640px) {
  .PoleImage {
    max-height: 100%;
    width: 100%;
    height: 100%;
  }
}
@media (max-width: 1720px) {
  .Grid {
    grid-template-rows: 2fr 1.9fr 10px;
  }
}

@media (max-width: 1450px) {
  .Grid {
    --heading-f-size: 50px;
    --text-f-size: 17px;
    grid-template-rows: 1fr 0.8fr 10px;
    min-height: 80vh;
  }
  .HeadingWrapper {
    align-self: flex-end;
  }
  .PoleImageWrapper {
    height: 70%;
  }
}
@media (max-width: 1270px) {
  .Grid {
    grid-template-rows: 0.6fr 0.8fr 10px;
    --heading-f-size: 30px;
    --text-f-size: 14px;
    margin: 0;
    min-height: 60vh;
  }
  .HeadingWrapper {
    align-self: flex-end;
    max-width: 85%;
  }
  .heading {
    line-height: normal;
  }
  .PoleImageWrapper {
    height: 70%;
  }
  .TextWrapper {
    padding: 0;
    max-width: 85%;
  }
}

@media (max-width: 1025px) {
  .Grid {
    grid-template-rows: 0.6fr 0.8fr 100px;
    --text-f-size: 14px;
    min-height: auto;
  }
  .PoleImageWrapper {
    padding: 0;
    height: 64%;
  }
  .PoleImage {
    width: 100%;
    height: 100%;
  }
  .HeadingWrapper {
    max-width: 85%;
  }
  .TextWrapper {
    margin: 0 auto 0 0;
    max-width: 85%;
  }
}

@media (max-width: 810px) {
  .Grid {
    grid-template-rows: 0.6fr 0.8fr 40px;
  }
}

@media (max-width: 768px) {
  .Grid {
    grid-template-rows: 0.5fr 0.8fr 40px;
  }
}

@media (max-width: 700px) {
  .Grid {
    grid-template-columns: 1fr;
    grid-template-rows: 0.5fr 0.6fr 1fr;
    grid-auto-rows: auto;
    width: 100%;
    margin: 0;
    --heading-f-size: 30px;
    --text-f-size: 14px;
  }
  .HeadingWrapper {
    grid-row: 1;
    grid-column: 1;
    padding: 2em 2em 0 0;
    justify-self: flex-start;
  }
  .TextWrapper {
    grid-row: 2;
    padding: 0 2em 0 0;
  }
  .PoleImageWrapper {
    grid-row: 3;
    grid-column: 1;
    justify-self: flex-end;
    height: 82%;
    width: 80%;
    padding-left: 0;
  }
  .PoleImage {
    width: 100%;
    object-fit: cover;
  }

  .Circle {
    grid-row: 3;
    height: 100%;
    grid-column: 1;
    border-radius: 100% 0% 100% 0% / 100% 100% 0% 0%;
  }
  .Layer {
    display: none;
  }
}
@media (max-width: 500px) {
  .HeadingWrapper,
  .TextWrapper {
    max-width: 100%;
  }
}

@media (max-width: 360px) {
  .Grid {
    grid-template-rows: 0.5fr 1fr 320px;
  }
  .PoleImageWrapper {
    height: 75%;
    width: 85%;
  }
  .HeadingWrapper,
  .TextWrapper {
    max-width: 100%;
  }
}

@media (max-width: 300px) {
  .Grid {
    grid-template-rows: 0.5fr 1fr 320px;
  }
  .PoleImageWrapper {
    height: 70%;
    width: 90%;
  }
}

@media (min-width: 1270px) {
  .TextWrapper {
    max-width: 80%;
  }
  .BigHeader {
    max-width: 85%;
    line-height: 1.3;
  }
}
@media (min-widdth: 1350px) {
  .BigHeader {
    line-height: 1.2;
  }
}

@media (min-width: 1026px) {
  .Grid {
    --text-f-size: 16px;
    --subtitle-f-size: 20px;
  }
}
@media (min-width: 1271px) {
  .Grid {
    --text-f-size: 17px;
    --heading-f-size: 50px;
  }
}
@media (min-width: 1750px) {
  .Grid {
    --text-f-size: 20px;
    --heading-f-size: 70px;
  }
}
</style>

<style>
:root {
  --mx: 1.25rem;
  --px: 1.25rem;
}
.HomePageMargin {
  margin-left: var(--mx);
  margin-right: var(--mx);
}
.HomePagePadding {
  padding-left: var(--px);
}
@media (min-width: 320px) {
  .HomePagePadding {
    --px: 2.5rem;
  }
  .HomePageMargin {
    --mx: 2.5rem;
  }
}
@media (min-width: 1024px) {
  .HomePagePadding {
    --px: 140px;
  }
  .HomePageMargin {
    --mx: 140px;
  }
}
@media (min-width: 1680px) {
  .HomePagePadding {
    --px: 200px;
  }
  .HomePageMargin {
    --mx: 200px;
  }
}

@media (min-width: 2550px) {
  .HomePageMargin {
    --mx: 300px;
  }
  .HomePagePadding {
    --px: 300px;
  }
}
</style>
